<template>
  <div id="app">
    <b-modal
      size="xl"
      id="modal-settings"
      ref="modal-settings"
      :title="'Paramètres'"
      hide-footer
    >
      <div class="p-fluid grid mt-3">
        <div class="field col-6 mt-2">
          <span class="p-float-label">
            <InputText id="inputtext-left" v-model="mail" />
            <label for="inputtext-left"
              >Mail de l'administrateur (envoi mails nouvelles
              installations)</label
            >
          </span>
        </div>

        <div class="float_right field col-12 mt-2">
          <Button label="Valider" @click="onSubmit()" />
        </div>

        <Message v-if="message" severity="success" class="mt-1">
          {{ message }}
        </Message>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Message from "primevue/message";

export default {
  name: "ModalSettings",
  props: {},
  components: {
    Button,
    InputText,
    Message,
  },
  data() {
    return {
      mail: null,
      message: null,
    };
  },

  async fetch() {},
  watch: {},
  async mounted() {
    this.getAdminMail();
  },
  // fetchOnServer: false,
  methods: {
    onSubmit() {
      this.createOrUpdateAdminUser();
    },
    getAdminMail() {
      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/installation/getAdminUser",
        {
          method: "get",
          // body: JSON.stringify({
          //   // componentId: 1,
          // }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          this.mail = json.adminUser;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createOrUpdateAdminUser() {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/installation/createOrUpdateAdminUser",
        {
          method: "post",
          body: JSON.stringify({
            mail: this.mail,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          this.message = json.message;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
@import "https://unpkg.com/primeflex@3.1.2/primeflex.css";
</style>

<style>
.float_left {
  float: left;
}
.float_right {
  float: right;
}
.select_installation_type {
  height: 48px;
}
.p-inline-message-text {
  font-size: 0.9rem !important;
}
.p-inline-message {
  height: 20px;
  margin-bottom: 10px;
}
.p-panel-header {
  color: red !important;
}
.p-inline-message-icon {
  display: none;
}
</style>
